export interface CreateUserRequest {
  firstName: string;
  id: string;
  email?: string;
}

export interface CreateUserResponse {
  firstName: string;
  id: string;
  email?: string;
  updatedAt?: string;
  isProfileUpdate?: boolean;
  mobile?: string;
  workspaceRoles: any;
  role?: string;
}

export interface InviteViaEmailRequest {
  inviteId: string;
  senderWorkspaceId: string;
  reInviteType?: string;
}

export interface InviteViaEmailResponse {
  success: boolean;
}

export interface ERPRequest {
  workspaceId: string;
  erpName: string;
  erpVersion: string;
}

export interface ERPResponse {
  erpDetails: ERPDetails;
  status: string;
  statusCode: number;
}

export interface ERPDetails {
  erpName: string;
  erpVersion: string;
  workspaceId: string;
  id: string;
  createdDate: Date;
  updatedDate: Date;
}

export interface ShareInviteResponse {
  id: string;
  phone: string;
  phone2: string;
  inviteType: string;
  userType: any;
  isActive: boolean;
  isArchive: boolean;
  senderUserId: string;
  invitedUserId: string;
  senderWorkspaceId: string;
  invitedWorkspaceId: string;
  status: string;
  createdDate: string;
  updatedDate: string;
  inviteId: string;
  inviteDetails: InviteDetails;
}

interface InviteDetails {
  id: string;
  inviteId: string;
  name: string;
  email: string;
  companyName: string;
  gstin: string;
  businessPAN: string;
  distributorCode: string;
  postalCode: string;
  physicalAddress: PhysicalAddress;
  shippingAddress: ShippingAddress;
  distributorChannel: string;
  CSTNumber: string;
  telephone: string;
  token: string;
  cityId: string;
  districtId: string;
  cityName: string;
  createdDate: string;
  updatedDate: string;
  dlExpiry: string;
  dlNumber: string;
  grossCreditLimit: number;
  creditLimitPeriod: number;
  tags: string;
  fulfillmentLocationCode: string;
  countryId: string;
  stateId: string;
}

interface PhysicalAddress {
  address1: string;
  address2: string;
}

interface ShippingAddress {
  shippingAddress1: string;
  shippingAddress2: string;
}

export interface ShareInviteRequest {
  customerId: string;
  params: {
    includeInviteDetails?: boolean;
  };
}

export interface CreateSellerRequest {
  gstIn?: string;
  spaceName: string;
  companyName?: string;
  mobile?: string;
  address: {
    address1: string;
    address2: string;
    city: string;
    state: string;
    pincode: string;
  };
  firstName: string;
  companyEmail: string;
  businessCategory: string;
  industry: string;
  planCode?: string;
  gstValidityEndDate?: string;
  defaultCurrencyCode?: string;
  timeZone?: string;
}

export interface SellerDetails {
  isEmail: boolean;
  phoneNumber: string;
  gstin: string;
  tradeName: string;
  companyName: string;
  address: string;
  city: string;
  state: string;
  pinCode: string;
  contactName: string;
  emailId: string;
  category: SellerDetailsBusinessCategory | undefined;
  industry: SellerDetailsIndustry | undefined;
  gstValidTill: string;
  planCode: string;
  selectedPlan: string;
}

export enum SignUpStepEnum {
  PHONE = 'PHONE',
  OTP = 'OTP',
  GST_DETAILS = 'GST_DETAILS',
  WITHOUT_GSTIN = 'WITHOUT_GSTIN',
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  BUSINESS_CATEGORY = 'BUSINESS_CATEGORY',
  YOUR_INDUSTRY = 'YOUR_INDUSTRY',
  PLAN_BUSINESS = 'PLAN_BUSINESS',
  LOADING = 'LOADING',
  LAUNCH = 'LAUNCH',
  ERROR = 'ERROR',
  CONTACT_US = 'CONTACT_US',
}

export enum SellerDetailsBusinessCategory {
  BRAND_OR_MANUFACTURER = 'BRAND_OR_MANUFACTURER',
  DISTRIBUTOR_OR_WHOLESALER = 'DISTRIBUTOR_OR_WHOLESALER',
  RETAILER = 'RETAILER',
}

export enum SellerDetailsAccountStatus {
  LIV = 'LIV',
  IMP = 'IMP',
  HLD = 'HLD',
}

export enum SellerDetailsIndustry {
  AGRICULTURE = 'AGRICULTURE',
  FMCG = 'FMCG',
  CONSTRUCTION = 'CONSTRUCTION',
  PIPES = 'PIPES',
  OIL = 'OIL',
  ELECTRONICS = 'ELECTRONICS',
  SCENTS_AND_FRAGRANCES = 'SCENTS_AND_FRAGRANCES',
  OTHERS = 'OTHERS',
  DAIRY = 'DAIRY',
  FASHION_AND_RETAIL = 'FASHION_AND_RETAIL',
  HEALTHCARE = 'HEALTHCARE',
  MANUFACTURING = 'MANUFACTURING',
}

export interface GSTDetailsResponse {
  firm_name: string;
  address: GSTAddress;
  valid_till: string;
  gstin_number: string;
}

export interface GSTAddress {
  bnm: string;
  st: string;
  loc: string;
  bno: string;
  dst: string;
  lt: string;
  locality: string;
  pncd: string;
  landMark: string;
  stcd: string;
  geocodelvl: string;
  flno: string;
  lg: string;
}
export interface BusinessPlanDetailsResponse {
  CurrencyCode: string;
  code: number;
  message: string;
  plans: Plan[];
  page_context: PageContext;
}

export interface BusinessPlanDetailsRequest {
  params: {
    sellerWorkspaceId: string;
  };
}

export interface SendAgreementDetailsRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    isAgreementAccepted: boolean;
    name: string;
    email: string;
    ipAddress: string;
  };
}
export interface Plan {
  plan_code: string;
  plan_id: string;
  name: string;
  product_name: string;
  billing_mode: string;
  description: string;
  status: string;
  status_formatted: string;
  product_id: string;
  tax_id: string;
  tax_name: string;
  tax_percentage: number;
  tax_type: string;
  trial_period: number;
  setup_fee: number;
  setup_fee_account_id: string;
  setup_fee_account_name: string;
  account_id: string;
  account: string;
  recurring_price: number;
  pricing_scheme: string;
  pricing_scheme_formatted: string;
  price_brackets: PriceBracket[];
  unit: string;
  interval: number;
  interval_unit: string;
  interval_unit_formatted: string;
  is_usage_enabled: boolean;
  billing_cycles: number;
  product_type: string;
  show_in_widget: boolean;
  store_description: string;
  store_markup_description: string;
  url: string;
  image_id: string;
  shipping_interval: number;
  shipping_interval_unit: string;
  group_name: string;
  internal_name: string;
  is_free_plan: boolean;
  created_time: string;
  created_time_formatted: string;
  created_at: string;
  created_at_formatted: string;
  updated_time: string;
  updated_time_formatted: string;
  addons: Addon[];
  custom_fields: any[];
  suggested?: boolean;
}

export interface PriceBracket {
  price: number;
}

export interface Addon {
  name: string;
  addon_code: string;
}

export interface PageContext {
  page: number;
  per_page: number;
  has_more_page: boolean;
  applied_filter: string;
  custom_fields: any[];
  sort_column: string;
  sort_order: string;
}

export interface PaymentStatusReq {
  params: {
    hostedPageId: string;
    sellerWorkspaceId: string;
  };
}

export interface PaymentStatusRes {
  status: string;
}

// First, add these types to your model.ts file
export interface QueryBizUserRequest {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  query: {
    environmentId: string;
    segmentId: string;
  };
  orderBy: {
    field: string;
    direction: string;
  };
}

export interface QueryBizUserResponse {
  data: {
    queryBizUser: {
      totalCount: number;
      edges: Array<{
        cursor: string;
        node: {
          id: string;
          createdAt: string;
          externalId: string;
          environmentId: string;
          data: any;
        };
      }>;
      pageInfo: {
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    };
  };
}

export interface UpgradePlanRequest {
  params: { sellerWorkspaceId: string };
  body: { plan_code: string };
  sellerWorkspaceId: string;
}
export interface UpgradePlanResponse {
  hostedpage_id: string;
  decrypted_hosted_page_id: string;
  status: string;
  message?: string;
  url: string;
  action: string;
  expiring_time: string;
  created_time: string;
}

export interface TopUpRequest {
  body: {
    workspaceId?: string;
    amount: number;
    platformCredit: number;
  };
  params: {
    sellerWorkspaceId: string;
  };
}

export interface TopUpResponse {
  accountBillingId: string;
  amount: number;
  consumptionCredit: number;
  createdDate: string;
  encryptedHostedPageId: string;
  hostedPageId: string;
  id: string;
  redirectUrl: string;
  status: string;
  transactionCredit: number;
  type: string;
  updatedDate: string;
  zohoInvoiceId: null;
  zohoPaymentId: null;
  zohoPlanCode: null;
  zohoWebhookPayload: null;
}

export interface SubscribePlanRequest {
  body: { plan: { plan_code: string }; workspaceId: string };
  params: { sellerWorkspaceId: string };
}
